import React from "react";
import { CheckCircle } from "lucide-react";

// Простая карточка функции без анимаций
const FeatureCard: React.FC<{
  feature: {
    imageSrc: string;
    title: string;
    description: string;
    benefits: string[];
  };
  index: number;
}> = ({ feature }) => {
  return (
    <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 mb-4 md:mb-6">
        <img
          src={feature.imageSrc}
          alt=""
          className="w-20 h-20 md:w-24 md:h-24 object-contain select-none"
          loading="lazy"
        />
        <h3 className="text-xl md:text-2xl font-bold text-slate-600">
          {feature.title}
        </h3>
      </div>

      <p className="text-gray-600 mb-5 md:mb-6 text-base md:text-lg leading-relaxed">
        {feature.description}
      </p>

      <ul className="space-y-2.5 md:space-y-3">
        {feature.benefits.map((benefit, benefitIndex) => (
          <li key={benefitIndex} className="flex items-start">
            <CheckCircle className="mt-0.5 h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
            <span className="text-gray-700 leading-snug">{benefit}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const FeaturesSection: React.FC = () => {

  const features = [
    {
      imageSrc: "/icons/icon-RentalCalendar.webp",
      title: "Умный Календарь",
      description: "Планируйте заказы и отслеживайте доступность оборудования в реальном времени",
      benefits: ["Онлайн-бронирование", "Автоматическое планирование", "Контроль доступности"],
    },
    {
      imageSrc: "/icons/icon-Inventory.webp",
      title: "Инвентаризация и Окупаемость",
      description: "Контролируйте оборудование и анализируйте рентабельность каждой единицы",
      benefits: ["Учет оборудования", "Анализ окупаемости", "Мониторинг состояния"],
    },
    {
      imageSrc: "/icons/icon-CrossPunkt.webp",
      title: "Кросс-Пункт",
      description: "Управляйте несколькими пунктами проката из единой системы",
      benefits: ["Единая система", "Кросс-Пункт переводы", "Централизованная отчетность"],
    },
    {
      imageSrc: "/icons/icon-Task.webp",
      title: "Уведомления и Задачи",
      description: "Автоматические напоминания о возврате, обслуживании и важных событиях",
      benefits: ["Автоматические напоминания", "Система задач", "Push-уведомления"],
    },
  ];

  return (
    <section id="features" className="py-20" style={{
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(248, 250, 252, 1) 10%, rgba(248, 250, 252, 1) 90%, rgba(255, 255, 255, 1) 100%)'
    }}>
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-left sm:text-center mb-16 px-[16px] sm:px-0">
          <h1 className="mb-4 sm:mb-8 text-slate-600 text-left sm:text-center mt-0 font-bold py-0 text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl leading-tight">
            Полный набор инструментов
          </h1>
          <p className="text-l text-gray-600 max-w-3xl mx-auto text-left sm:text-center">
            Для эффективного управления прокатным бизнесом
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              feature={feature}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};